<script>
import FormSelect from "@/src/components/form/Select.vue";
import CustomDatePickerRange from "@components/CustomDatePickerRange";
import {
  euroCouponsIssueMethods,
  euroCouponsTutorialMethods,
  euroHabeasDataReportsManagement,
  captacionMethods,
} from "@state/helpers";
export default {
  name: "ModalDetail",
  components: { FormSelect, CustomDatePickerRange },
  props: {
    instanceJson: {
      type: Object,
      required: false,
      default: false,
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      toDetail: {},
    };
  },
  computed: {},

  mounted() {},
  methods: {},
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="`${$t('detail_of')} Habeas Data`"
    ok-only
    size="lg"
    hide-footer
    @hidden="oncancel"
  >
    <b-container class="p-0">
      <b-list-group class="mb-3 border border-primary shadow">
        <div class="mb-1 border border-primary shadow">
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            <b class="text-primary"
              ><i class="fas fa-ban"></i> {{ $t("Formularios rechazados") }}</b
            >
            <p class="m-0 p-0" variant="primary" style="font-size: 13px">
              {{ instanceJson.reject_habeas }}
            </p>
          </b-list-group-item>
          <b-list-group-item class="d-flex justify-content-between align-items-center">
            <b class="text-primary"
              ><i class="fas fa-paper-plane"></i> {{ $t("Formularios enviados") }}</b
            >
            <p class="m-0 p-0" variant="primary" style="font-size: 13px">
              {{ instanceJson.sent_habeas }}
            </p>
          </b-list-group-item>

          <b-list-group-item class="d-flex justify-content-between align-items-center">
            <b class="text-primary"
              ><i class="fas fa-face-smile-wink"></i>
              {{ $t("Formularios ya registrados") }}</b
            >
            <p class="m-0 p-0" variant="primary" style="font-size: 13px">
              {{ instanceJson.past_send }}
            </p>
          </b-list-group-item>

          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            style="background-color: #75b798"
          >
            <b class="text-primary"
              ><i class="fas fa-face-smile-wink"></i>
              {{ $t("Total de acciones del formulario") }}</b
            >
            <p class="m-0 p-0" variant="primary" style="font-size: 13px; color: white">
              {{
                instanceJson.sent_habeas +
                instanceJson.reject_habeas +
                instanceJson.past_send
              }}
            </p>
          </b-list-group-item>
        </div>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          <b class="text-primary"
            ><i class="fas fa-file-invoice-dollar"></i> {{ $t("Total Facturas") }}</b
          >
          <b-badge variant="primary" style="font-size: 13px">{{
            instanceJson.total_sales
          }}</b-badge>
        </b-list-group-item>
        <b-list-group-item
          class="d-flex justify-content-between align-items-center bg-danger"
        >
          <b class="text-primary"
            ><i class="fas fa-face-smile-upside-down"></i>
            {{ $t("Total acciones no realizadas") }}</b
          >
          <b-badge variant="primary" style="font-size: 13px">{{
            instanceJson.total_sales -
            (instanceJson.sent_habeas +
              instanceJson.reject_habeas +
              instanceJson.past_send)
          }}</b-badge>
        </b-list-group-item>
      </b-list-group>
    </b-container>
  </b-modal>
</template>
<style lang="scss"></style>
